import type { FC } from 'react'
import sanitizeHtml from 'sanitize-html'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

interface CDPFeaturesProps {
  heading?: string
  features: {
    heading: string
    copy: {
      paragraph: string
    }[]
  }[]
}

const CDPFeatures: FC<CDPFeaturesProps> = ({ heading, features }) => (
  <StyledSectionBase variant="centered">
    {heading && (
      <Section.Copy>
        <CopyTextBase centered={true}>
          <StyledHeading tag="h2">{heading}</StyledHeading>
        </CopyTextBase>
      </Section.Copy>
    )}
    <Section.Contents>
      <StyledColumnTrack columns={1} overrides={{ lg: 3 }}>
        {features.map(({ heading, copy }) => (
          <CopyTextBase key={heading}>
            <CopyText.Heading variant="h4">{heading}</CopyText.Heading>
            {copy.map((text, index) => (
              <CopyText.Description
                key={index}
                tag="p"
                variant="pMedium"
                dangerouslySetInnerHTML={{
                  __html: sanitizeHtml(text.paragraph, { allowedTags: [`a`] }),
                }}
              />
            ))}
          </CopyTextBase>
        ))}
      </StyledColumnTrack>
    </Section.Contents>
  </StyledSectionBase>
)

export default CDPFeatures

const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 0px;
    row-gap: 20px;
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      row-gap: 60px;
    }
  }
`

const StyledColumnTrack = styled(ColumnTrack)`
  max-width: 1120px;
  margin: 0 auto;
  column-gap: 48px;
`

const StyledHeading = styled(CopyText.Heading)`
  text-align: start;
  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    text-align: center;
  }
`
